import React from "react";
import { Button, Card, Grid, Stack, TextField } from "@mui/material";
import Select from "react-select";

const PollForOptions = [
  { label: "All", value: 0 },
  { label: "LVB Prime", value: 4 },
  { label: "State", value: 1 },
  { label: "City", value: 2 }
];
const PollStatusOptions = [
  { label: "All", value: 0 },
  { label: "Pending", value: 1 },
  { label: "Completed", value: 2 }
];
const PollSendStatusOptions = [
  { label: "All", value: -1 },
  { label: "Unsent", value: 0 },
  { label: "Sent", value: 1 }
];

function PollFilters({ pollFilters, setPollFilters }) {
  return (
    <Card className="p-20 mb-15">
      <Grid container spacing={2} sx={{ alignItems: "center" }}>
        <Grid item xs={2}>
          <Stack sx={{ my: "5px" }}>
            <label>Poll For</label>
            <Select
              menuPortalTarget={document.body}
              value={PollForOptions.find((c) => c.value === pollFilters.p_type) || PollForOptions[0]}
              onChange={(e) => setPollFilters({ ...pollFilters, p_type: e.value })}
              options={PollForOptions}
            />
          </Stack>
        </Grid>
        <Grid item xs={2}>
          <Stack>
            <label>Poll Status</label>
            <Select
              menuPortalTarget={document.body}
              value={
                PollStatusOptions.find((c) => c.value === pollFilters.poll_status) ||
                PollStatusOptions[0]
              }
              onChange={(e) => setPollFilters({ ...pollFilters, poll_status: e.value })}
              options={PollStatusOptions}
            />
          </Stack>
        </Grid>
        <Grid item xs={2}>
          <Stack>
            <label>Send Status</label>
            <Select
              menuPortalTarget={document.body}
              value={
                PollSendStatusOptions.find((c) => c.value === pollFilters.poll_send_status) ||
                PollSendStatusOptions[0]
              }
              onChange={(e) => setPollFilters({ ...pollFilters, poll_send_status: e.value })}
              options={PollSendStatusOptions}
            />
          </Stack>
        </Grid>
        <Grid item xs={4}>
          <Stack spacing={10}>
            <TextField
              style={{ marginTop: "20px" }}
              fullWidth
              autoComplete="off"
              type="text"
              size="small"
              label="Search"
              value={pollFilters.search}
              onChange={(e) => setPollFilters({ ...pollFilters, search: e.target.value })}
            />
          </Stack>
        </Grid>
        <Grid
          item
          xs={1}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            marginTop: "20px"
          }}
        >
          <Button
            onClick={() =>
              setPollFilters({ p_type: 0, poll_status: 0, poll_send_status: -1, search: "" })
            }
            variant="contained"
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}
export default PollFilters;
